/* CILLE — Mått i köprutan.
   Läser produktens cille.matt-metafält (window.ppMatt) och följer variantväljaren,
   så att kunden alltid ser måtten för exakt den variant hon har valt.
   Måtten kommer ur leverantörens prislista — se claude/113 i projektet. */
(function () {
  var box = document.getElementById('ppMatt');
  var data = window.ppMatt;
  if (!box || !data) return;

  var map = data.varianter || {};
  var fallback = data.standard || '';
  if (!fallback && !Object.keys(map).length) return;

  var input = document.getElementById('ppVariant');

  var label = document.createElement('span');
  label.className = 'pp-mattl';
  label.textContent = 'Mått';
  var value = document.createElement('span');
  value.className = 'pp-mattv';
  box.appendChild(label);
  box.appendChild(value);

  if (data.material) {
    var mat = document.createElement('span');
    mat.className = 'pp-mattm';
    mat.textContent = data.material;
    box.appendChild(mat);
  }

  function paint() {
    var id = input && input.value ? String(input.value) : '';
    var txt = (id && map[id]) || fallback;
    if (!txt) { box.setAttribute('hidden', ''); return; }
    if (value.textContent !== txt) value.textContent = txt;
    box.removeAttribute('hidden');
  }

  paint();

  /* cille-product.js writes the chosen variant into #ppVariant on click.
     This file is deferred after it, so its listener is bound second and runs
     second; the setTimeout is a belt-and-braces guard against ordering. */
  document.querySelectorAll('.pp-optbtn').forEach(function (b) {
    b.addEventListener('click', function () { setTimeout(paint, 0); });
  });
})();
